import LoyaltyNavLink from '@/components/account/headerLink';
import { ConnectedPersonIcon } from '@/components/account/uielements';
import { styled } from '@/components/content/stitches';
import { GenericRouteAccessor } from '@/components/genericRouteAccessor';
import { HeaderIconLink, Signin } from '@/components/header/sign-in';
import { LOYALTY_ROUTES, ROUTES } from '@/constants/routes';
import { useSelector } from '@/redux';
import { getFontStyles } from '@/redux/cmsConfig/utils';
import { safelyGetString } from '@/utils/stringHelpers';

export function Account() {
  const { strings } = useSelector((state) => state.app.cmsConfig);
  const config = useSelector((state) => state.app.cmsConfig.webConfig);
  const me = useSelector((state) => state.app.me.data);
  // Only raised when a loyalty token exists (`fetchMeSaga` bails before the request
  // otherwise), so it means "signed in, profile unreachable" — not "signed out".
  const meConnectionError = useSelector((state) => state.app.me.meConnectionError);

  if (config.accounts.disable_accounts) {
    return null;
  }

  return (
    <>
      <GenericRouteAccessor
        allowedPages={{
          [ROUTES.HOMEPAGE]: { exactMatch: true },
          [ROUTES.ACCOUNT]: { exactMatch: true },
          [LOYALTY_ROUTES.REWARDS]: { exactMatch: true },
          [LOYALTY_ROUTES.ORDER_HISTORY]: { exactMatch: true },
          [ROUTES.STORE]: null,
          [ROUTES.PAGE]: null,
          [ROUTES.STORES]: null,
          [ROUTES.CHECKOUT]: {
            exactMatch: true,
            hideOnMobile: true,
          },
        }}
        component={
          <AccountContainer
            css={{
              'a, button': getFontStyles(config.header.font, ['color', 'font_family', 'font_size']),
            }}
          >
            {me?.id ? (
              <LoyaltyNavLink me={me} />
            ) : meConnectionError ? (
              // A signed-in diner whose profile failed to load at the network layer used
              // to be shown "Sign In/Join" (TEAM-14780 QA). Point them at their account,
              // which carries the connection message and retry, instead.
              <HeaderIconLink href={ROUTES.ACCOUNT} aria-label="My account">
                <ConnectedPersonIcon />
                My Account
              </HeaderIconLink>
            ) : (
              <Signin>{safelyGetString(strings, 'global_header.sign_in_cta')}</Signin>
            )}
          </AccountContainer>
        }
      />
    </>
  );
}

const AccountContainer = styled('div', {
  'a, button': {
    alignItems: 'center',
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    display: 'flex',
    height: '$12',
    justifyContent: 'center',

    '@md': {
      height: '$20',
      marginLeft: 0,
    },
  },

  '@print': {
    display: 'none',
  },
});
